export class PAReviewAnswerItemModel {
    constructor() {
        this.questionText = "";
        this.answerText = "";
        this.isMandatory = false;
        this.listOrder = 0;
        this.listDescription = "";
        this.employeeId = 0;
        this.isReadOnly = false;
        this.clientCommentItems = [];
        this.commentItems = [];
    }
}
export default class PAReviewAnswerItem extends PAReviewAnswerItemModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
